import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-qt-range',
  templateUrl: './qt-range.component.html',
  styleUrls: [],
  standalone: false
})
export class QtRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
